import { Coffee, Store, Check } from "lucide-react";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import { Reveal, SectionLabel, Stagger, Item } from "../components/Reveal";
import { WhatsAppButton } from "../components/CTA";
import { useContent } from "../data/siteContent";

const forCustomers = [
  "Order on the way, pay in the app",
  "Pick up at the express counter",
  "No queue",
];

const forCafes = [
  "No delivery commission",
  "Faster rush hours, tables freed up",
  "A simple tablet screen with two buttons — Accept and Ready",
  "Works alongside your current billing",
];

export default function Quikpik() {
  const { quikpik } = useContent();
  return (
    <div data-testid="quikpik-page">
      <SEO title="Quikpik by Allcov — Pre-order & Pickup for Cafes" description="Customers pre-order and pick up at the counter. No queue, no delivery commission. Onboarding cafes in Raj Nagar and RDC, Ghaziabad." path="/quikpik" />
      <PageHero
        eyebrow="Quikpik by Allcov"
        title="Skip the line. Just Quikpik."
        line="A pre-order and pickup app for cafes, built by Allcov."
        testid="quikpik"
      />

      <section className="py-20 lg:py-28" data-testid="quikpik-sides">
        <div className="mx-auto grid max-w-7xl gap-6 px-6 md:grid-cols-2 lg:px-10">
          <Reveal>
            <div className="h-full border border-line bg-surface p-8">
              <Coffee size={26} className="text-pop" strokeWidth={1.5} />
              <h2 className="mt-6 font-batangas text-2xl tracking-tight">For customers</h2>
              <ul className="mt-5 space-y-3">
                {forCustomers.map((c) => (
                  <li key={c} className="flex items-start gap-3 text-sm text-mut">
                    <Check size={15} className="mt-0.5 shrink-0 text-pop" />
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="h-full border border-line bg-surface p-8">
              <Store size={26} className="text-pop" strokeWidth={1.5} />
              <h2 className="mt-6 font-batangas text-2xl tracking-tight">For cafes</h2>
              <ul className="mt-5 space-y-3">
                {forCafes.map((c) => (
                  <li key={c} className="flex items-start gap-3 text-sm text-mut">
                    <Check size={15} className="mt-0.5 shrink-0 text-pop" />
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="section-light py-20 lg:py-28" data-testid="quikpik-pilot">
        <div className="mx-auto max-w-4xl px-6 lg:px-10">
          <Reveal><SectionLabel>The Pilot</SectionLabel></Reveal>
          <span className="mb-5 inline-block border border-myrtle/40 bg-myrtle/10 px-3 py-1.5 text-[10px] uppercase tracking-[0.25em] text-pop" data-testid="quikpik-status">
            {quikpik.status}
          </span>
          <h2 className="font-batangas text-3xl leading-tight tracking-tight md:text-4xl" data-testid="quikpik-area">
            {quikpik.area}
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-mut" data-testid="quikpik-offer">
              {quikpik.offer}
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-9">
              <WhatsAppButton label="Partner with Quikpik" testid="quikpik-partner-page" text={quikpik.wa_message} />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
